import Standup from './Standup';

export default Standup;